import { User } from "../providers/user-provider";
import { clientCompanyPath, backofficeCompanyPath } from "../paths/paths";

// "Gestionnaire" (client manager ou driver manager) : administre au moins
// une entreprise (cf. User.entreprises, alimenté par entrepriseAdministrateurs
// côté API - à ne pas confondre avec User.entreprisesDisponibles qui liste
// toutes les entreprises dont le contact fait partie, y compris comme simple
// collaborateur/chauffeur). Un simple collaborateur/chauffeur n'administre
// aucune entreprise.
export const isEntrepriseManager = (me: User | null): boolean =>
  (me?.entreprises?.length ?? 0) > 0;

/**
 * Quand l'entreprise active change pendant qu'on est sur l'espace "mon
 * entreprise", il faut suivre le contact vers le bon espace (client ou
 * backoffice) plutôt que de le laisser sur une page qui ne correspond plus au
 * type de l'entreprise nouvellement sélectionnée. Retourne `null` si aucune
 * redirection n'est nécessaire (page hors "mon entreprise", ou déjà au bon
 * endroit).
 */
export const companyRedirectPath = (
  pathname: string,
  entrepriseActive: User["entrepriseActive"],
): string | null => {
  const onClientCompany = pathname.startsWith(clientCompanyPath);
  const onBackofficeCompany = pathname.startsWith(backofficeCompanyPath);
  if (!onClientCompany && !onBackofficeCompany) return null;

  // Une entreprise peut être à la fois client et partenaire : le backoffice
  // l'emporte, comme pour les liens du header (cf. HeaderClient).
  const target = entrepriseActive?.isPartenaire ? backofficeCompanyPath : clientCompanyPath;
  const alreadyThere = target === clientCompanyPath ? onClientCompany : onBackofficeCompany;

  return alreadyThere ? null : target;
};
